/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  Title,
  User,
} from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import {UserRegisterFacade} from "../../root/facade";
import {UserSignUp} from "../../root/model";

@Injectable()
export class RegisterComponentService {
  constructor(
    protected userRegisterFacade: UserRegisterFacade,
    protected globalMessageService: GlobalMessageService
  ) {}

  /**
   * Register a new user.
   *
   * @param user as UserSignUp
   */
  register(user: UserSignUp): Observable<User> {
    return this.userRegisterFacade.register(user);
  }

  /**
   * Returns titles that can be used for the user profiles.
   */
  getTitles(): Observable<Title[]> {
    return this.userRegisterFacade.getTitles();
  }

  /**
   * Show the message after successful registration.
   */
  postRegisterMessage(): void {
    this.globalMessageService.add(
      { key: 'register.postRegisterMessage' },
      GlobalMessageType.MSG_TYPE_CONFIRMATION
    );
  }
}
